module.exports = __webpack_public_path__ + "static/media/Colette Wing Single Headboard - 120 cm_Black.fc20df75.png";